import {Inertia} from "@inertiajs/inertia";
import LandingLayout from '@/Layouts/LandingLayout'
import { useTitle } from '@/Utilities/Hooks'
import { Container } from '@/Components/'
import React, {useState} from "react";
import {LabeledInput} from "@/Components/Form";

export default function General({
  flash,
  errors,
  token
}) {
  useTitle('Update password')

  const [values, setValues] = useState({
    newPassword: "",
    repeatNewPassword: "",
    email: ""
  })

  function handleChange(e) {
    const key = e.target.id;
    const value = e.target.value
    setValues(values => ({
      ...values, [key]: value,
    }))

  }

  function handleSubmit(e) {
    e.preventDefault()

    if (!isValid()) {
      return;
    }

    Inertia.put('/password-update', {'email': values.email, 'password': values.newPassword, token}, {
      onSuccess: (() => {
        setValues({
          newPassword: "",
          repeatNewPassword: "",
          email: ""
        });
      })
    })
  }

  function SubmitButton() {
    let disabled = false

    // Check if we're not dirty or does not have a valid email
    if (!isValid()) {
      disabled = true
    }

    return <button
      disabled={disabled}
      className="self-end px-4 py-4 mt-4 text-white bg-blue hover:bg-blue-light active:bg-teal-700 disabled:opacity-50 disabled:cursor-default disabled:hover:bg-blue"
    >
      Update password
    </button>
  }

  function isValid() {
    return (values.newPassword === values.repeatNewPassword && values.newPassword.length >= 8);
  }

  return (
    <Container className="relative flex flex-col flex-wrap max-w-5xl p-4 overflow-visible bg-white md:flex-row xl:dots-topright xl:dots-bottomleft md:p-8 lg:p-16 md:mt-10">
      <div className="flex flex-col items-stretch w-full">
        <a href="https://gidas.se">
          <img
            className="self-start w-16 h-16 mb-8"
            src="/images/logo_dark.png"
            alt="Gidås logo"
          />
        </a>

        <div className="flex flex-row self-center flex-shrink-0 w-2/3 my-4">

            <div className="w-full ">
              <h1 className="mb-4 text-center header-1">Update your password</h1>
              <p className="mt-4 text-center">Enter your new password below to get started.</p>
              <form className="flex flex-col mt-8" onSubmit={handleSubmit}>

                <LabeledInput
                  title="Your email"
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Enter your email"
                  value={values.email}
                  onChange={handleChange}
                  className="mb-4"
                />

                <LabeledInput
                  title="New password"
                  id="newPassword"
                  name="newPassword"
                  type="password"
                  placeholder="Enter password"
                  value={values.newPassword}
                  onChange={handleChange}
                  className="mb-4"
                />

                <LabeledInput
                  title="Repeat new password"
                  id="repeatNewPassword"
                  name="repeatNewPassword"
                  type="password"
                  placeholder="Enter password"
                  value={values.repeatNewPassword}
                  onChange={handleChange}
                />

                <SubmitButton/>

                {errors.status && (
                  <p className="p-2 mt-2 bg-red-100">{errors.status}</p>
                )}

                {flash.status && (
                  <p className="p-2 mt-2 bg-green-100">{flash.status}</p>
                )}
              </form>
            </div>

        </div>

      </div>
    </Container>

  )
}

General.layout = page => (
  <LandingLayout>{page}</LandingLayout>
)
